export default __webpack_public_path__ + "static/media/jober.a501e585.png";